module.exports = __webpack_public_path__ + "img/area_2.e79a52b0.png";